var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categorizedCategories),function(categorizedRootCategory,index){return _c('div',{key:index,staticClass:"margin-bottom-5"},[_c('strong',[_vm._v(_vm._s(categorizedRootCategory.name))]),(
        categorizedRootCategory.children &&
        categorizedRootCategory.children.length > 0
      )?_c('div',{staticClass:"padding-left-10"},[_c('ExpencesCategories',{attrs:{"categorizedCategories":categorizedRootCategory.children,"isSomeCategoryEditing":_vm.isSomeCategoryEditing,"rawCategorizedCategories":_vm.rawCategorizedCategories}})],1):_c('div',[_vm._v("-")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }